import React from 'react';
import styled, { css } from 'styled-components';
import mq from '../utils/mq';
import Title from './title';
import { Text } from '../components/UIKit/system';
import Button from './button';
import BackgroundImg from '../images/cta-banner-background.png';
import { Box, Flex } from './UIKit/system';
import Container from './container';
import { STANDARD_PADDING, OFFSET_SIDE_SM } from '../constants';
import parseStoryblokLink from '../utils/parseStoryblokLink';

const BannerWithCtaOuterContainer = styled(Box)`
  display: flex;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;

  ${mq.mobile(css`
    width: 100%;
    padding: 0px;
  `)};
`;

const StyledContainer = styled(Container)`
  ${mq.mobile(css`
    width: 100%;
    border-left-width: 0px;
    border-right-width: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  `)};
`;

const BannerWithCtaContainer = styled(Flex)`
  text-align: center;
  background-size: cover;
  background-position: center;
  background-color: #f8f8f8;
  justify-content: center;
  padding-top: 75px;
  padding-bottom: 52px;
  border-radius: var(--Radius-Radius-3, 16px);
  ${mq.mobile(css`
    align-items: flex-start;
    padding-left: ${OFFSET_SIDE_SM}px;
    padding-right: ${OFFSET_SIDE_SM}px;
    background: unset !important;
    background-color: #f8f8f8 !important;
    padding-top: 32px;
    padding-bottom: 32px;
  `)};
`;

const StyledTitle = styled(Title)`
  font-weight: bold;
  font-size: 42px;
  line-height: 115%;
  text-align: center;
  max-width: 648px;
  margin-bottom: 17px;
  color: ${Title.color};
  ${mq.mobile(css`
    padding-right: ${OFFSET_SIDE_SM}px;
    font-size: 32px;
    line-height: 38px;
    text-align: left;
    max-width: unset;
  `)};
`;

const Paragraph = styled(Text)`
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  max-width: 769px;
  text-wrap: balance;
  margin-bottom: 31px;
  color: ${Text.color};
  ${mq.tablet(css`
    width: 90%;
  `)};
  ${mq.mobile(css`
    padding-right: ${OFFSET_SIDE_SM}px;
    width: 100%;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    max-width: unset;
  `)};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  ${mq.mobile(css`
    flex-direction: column;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
  `)};
`;

function BannerWithCta({
  title,
  text,
  button,
  backgroundImage,
  color,
  whiteTransparent = true,
  hasContainer = true
}) {
  const colorProps = {};
  if (color) Reflect.set(colorProps, 'color', color);

  const Banner = () => (
    <BannerWithCtaContainer
      flexDirection={'column'}
      alignItems={'center'}
      style={{
        backgroundImage: `url(${backgroundImage?.filename || BackgroundImg})`
      }}
    >
      <StyledTitle {...colorProps} html={title} />
      <Paragraph color={color || '#565656'} html={text} />
      <ButtonContainer>
        {button &&
          button?.length > 0 &&
          button?.map((buttonItem, index) => (
            <Button
              key={index}
              {...buttonItem}
              to={`/${parseStoryblokLink(buttonItem.link)}`}
              borderGrey={
                button?.length > 1 && index === button?.length - 1
                  ? true
                  : false
              }
            />
          ))}
      </ButtonContainer>
    </BannerWithCtaContainer>
  );

  if (!hasContainer) return <Banner />;

  return (
    <BannerWithCtaOuterContainer py={[STANDARD_PADDING, 32]}>
      <StyledContainer>
        <Banner />
      </StyledContainer>
    </BannerWithCtaOuterContainer>
  );
}

export default BannerWithCta;
